exports.AnnounceDurations = {"liquidooze.wav":3.432625,"woodhammer.wav":1.7198125};